import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import CalendarView from '../views/CalendarView.vue'
import CarLine from '../views/CarLine.vue'
import Login from '../views/Login.vue'
import CarLineDetail from '../views/CarLineDetail.vue'
import ReserveCar from '../views/ReserveCar.vue'

import Reservesure from '../views/Reservesure.vue'
import Reservesub from '../views/Reservesub.vue'
import userinfo from '../views/userinfo.vue'
import OrderInfo from '../views/OrderInfo.vue'
import ModifyPwd from '../views/ModifyPwd.vue'
import OrderInfoDetail from '../views/OrderInfoDetail.vue'
import Points from '../views/Points.vue'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)

}

const routes = [{
		path: '/',
		name: 'home',
		component: HomeView,
		meta: {
			title: '首页',
			requireAuth: true
		},
		children: [

			{


				path: '/',
				name: 'Calendar',
				component: CalendarView,
				meta: {
					title: '日历',
					requireAuth: true
				},
			},
			
			{
			
			
				path: '/Calendar',
				name: 'Calendar',
				component: CalendarView,
				meta: {
					title: '日历',
					requireAuth: true
				},
			},
			
			
			{
				path: '/CarLine',
				name: 'CarLine',
				component: CarLine,
				meta: {
					title: '车辆预约列表',
					requireAuth: true
				},
			},
			{
				path: '/CarLineDetail',
				name: 'CarLineDetail',
				component: CarLineDetail,
				meta: {
					title: '车辆预约详情',
					requireAuth: true
				},
			},
			{
				path: '/ReserveCar',
				name: 'ReserveCar',
			 component: ReserveCar,
				meta: {
					title: '车辆预约',
					requireAuth: true
				},
			},

			{
				path: '/Reservesure',
				name: 'Reservesure',
				component: Reservesure,
				meta: {
					title: '车辆预约-确定页面',
					requireAuth: true
				},
			},
			{
				path: '/Reservesub',
				name: 'Reservesub',
				component: Reservesub,
				meta: {
					title: '车辆预约-提交页面',
					requireAuth: true
				},
			},
			{
				path: '/userinfo',
				name: 'userinfo',
				component: userinfo,
				meta: {
					title: '个人信息',
					requireAuth: true
				},
			},
			{
				path: '/OrderInfo',
				name: 'OrderInfo',
				component: OrderInfo,
				meta: {
					title: '预约订单',
					requireAuth: true
				},
			},
			{
				path: '/ModifyPwd',
				name: 'ModifyPwd',
				component: ModifyPwd,
				meta: {
					title: '修改密码',
					requireAuth: true
				},
			},
			{
				path: '/OrderInfoDetail',
				name: 'OrderInfoDetail',
				component: OrderInfoDetail,
				meta: {
					title: '预约订单详情',
					requireAuth: true
				},
			},
			{
				path: '/Points',
				name: 'Points',
				component: Points,
				meta: {
					title: '我的积分',
					requireAuth: true
				},
			}
		]
	},

	{
		path: '/Login',
		name: 'Login',
		component: Login,
		meta: {
			title: '登录',
			requireAuth: true
		},
	},

]

const router = new VueRouter({
	base: process.env.BASE_URL,
	routes
})

router.afterEach((to, from, next) => {
	window.scrollTo(0, 0)
})

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	document.title = "MR.HIROレンタカー｜大阪市大正区｜ハチロク・GT-R・RX-7等のカーレンタルショップ"
	if (to.meta.title) {
		next();
	}

	// if (to.matched.some((auth) => auth.meta.requireAuth)) {
	// 	// let YHSEQNUM = localStorage.getItem("YHSEQNUM");
	// 	// if (YHSEQNUM) {
	// 	// 	next();
	// 	// } else {
	// 	// 	if (to.path == '/login') { //如果是登录页面路径，就直接next()
	// 	// 		next();
	// 	// 	} else { //不然就跳转到登录；
	// 	// 		next({
	// 	// 			path: '/login',
	// 	// 		})
	// 	// 	}
	// 	// }
	// } else {
	// 	next();
	// }
})

export default router
